export default "__VITE_ASSET__DWDK_NwY__"